export default {
    navHeight: '70px',
    maxContainerWidth: 1440,
};
